// extracted by mini-css-extract-plugin
module.exports = {"event":"Event_event__s57V6","title":"Event_title__tkBtd"};